import axios from 'axios';

import { IKunde, KundeCriteria } from '@/shared/model/kunde.model';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

const baseApiUrl = 'api/kundes';

export default class KundeService {
  public setActive(id: number, active: boolean) {
    axios.post(`${baseApiUrl}Active/${id}/${active}`);
  }

  public find(id: number): Promise<IKunde> {
    return new Promise<IKunde>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveAll(): Promise<any> {
    return axios.get(`${baseApiUrl}`);
  }

  public retrieveAllActive(): Promise<any> {
    return axios.get(`${baseApiUrl}Active`);
  }

  public retrieveAllSorted(): Promise<any> {
    return axios.get(`${baseApiUrl}FilterNP`);
  }

  public retrieve(req?: any, criteria?: KundeCriteria): Promise<any> {
    return axios.post(`${baseApiUrl}Filter?${buildPaginationQueryOpts(req)}`, criteria);
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IKunde): Promise<IKunde> {
    return new Promise<IKunde>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IKunde): Promise<IKunde> {
    return new Promise<IKunde>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
